import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { copyToClipboard } from '../../../utils/downloadUtils';
import { POLICY_TEMPLATES } from '../constants/policyTemplates';
export default function PolicyTemplatesModal({ onClose }) {
    const [copiedTemplate, setCopiedTemplate] = useState(null);
    const handleCopy = async (templateName, yaml)=>{
        const success = await copyToClipboard(yaml);
        if (success) {
            setCopiedTemplate(templateName);
            setTimeout(()=>setCopiedTemplate(null), 2000);
        }
    };
    return /*#__PURE__*/ _jsx("div", {
        className: "fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center p-4 z-50",
        children: /*#__PURE__*/ _jsxs("div", {
            className: "bg-card rounded-lg border border-border shadow-lg p-6 w-full max-w-4xl max-h-[90vh] overflow-y-auto",
            children: [
                /*#__PURE__*/ _jsx("h3", {
                    className: "text-lg font-semibold text-card-foreground mb-4",
                    children: "Policy Templates"
                }),
                /*#__PURE__*/ _jsx("p", {
                    className: "text-muted-foreground mb-6",
                    children: "Common policy patterns to get you started. Copy and modify these policies as needed."
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "space-y-6",
                    children: POLICY_TEMPLATES.map((template)=>/*#__PURE__*/ _jsxs("div", {
                            className: "border rounded-lg p-4",
                            children: [
                                /*#__PURE__*/ _jsx("h4", {
                                    className: "font-semibold text-card-foreground mb-2",
                                    children: template.name
                                }),
                                /*#__PURE__*/ _jsx("p", {
                                    className: "text-muted-foreground text-sm mb-3",
                                    children: template.description
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "bg-muted rounded-md p-3",
                                    children: /*#__PURE__*/ _jsx("pre", {
                                        className: "text-sm font-mono text-card-foreground whitespace-pre-wrap overflow-x-auto",
                                        children: template.yaml
                                    })
                                }),
                                /*#__PURE__*/ _jsx("div", {
                                    className: "mt-3 flex space-x-2",
                                    children: /*#__PURE__*/ _jsx("button", {
                                        type: "button",
                                        onClick: ()=>handleCopy(template.name, template.yaml),
                                        className: `px-3 py-1 text-sm rounded transition-colors ${copiedTemplate === template.name ? 'bg-accent text-primary-foreground hover:bg-accent/90' : 'bg-primary text-primary-foreground hover:bg-primary/90'}`,
                                        children: copiedTemplate === template.name ? '✓ Copied' : 'Copy YAML'
                                    })
                                })
                            ]
                        }, template.name))
                }),
                /*#__PURE__*/ _jsxs("div", {
                    className: "bg-primary/10 border border-primary/30 rounded-md p-4 mt-6",
                    children: [
                        /*#__PURE__*/ _jsx("h4", {
                            className: "font-semibold text-primary mb-2",
                            children: "Documentation"
                        }),
                        /*#__PURE__*/ _jsxs("p", {
                            className: "text-primary text-sm",
                            children: [
                                "For more policy examples and detailed documentation, visit the",
                                ' ',
                                /*#__PURE__*/ _jsx("a", {
                                    href: "https://docs.cerbos.dev",
                                    target: "_blank",
                                    rel: "noopener noreferrer",
                                    className: "underline",
                                    children: "Cerbos Documentation"
                                }),
                                "."
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx("div", {
                    className: "flex justify-end mt-6",
                    children: /*#__PURE__*/ _jsx("button", {
                        type: "button",
                        onClick: onClose,
                        className: "px-4 py-2 bg-muted text-muted-foreground rounded-md hover:bg-muted/80 transition-colors",
                        children: "Close"
                    })
                })
            ]
        })
    });
}
